export default "__VITE_ASSET__AyY5NzPq__"